module.exports = __webpack_public_path__ + "static/img/bg_guest.c180189.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/ibroadcast/bg_guest.jpg
// module id = 318
// module chunks = 2